import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { selectors as licenseSelectors } from 'store/licenseManager'
import {
  operations as ssapiOperations,
  selectors as ssapiSelectors,
} from 'store/ssapiManager'
import AdminK8PrepareMultiSiteView from './component'
import { addProgressToSites } from './helpers'

const AdminK8PrepareMultiSiteViewContainer = ({
  fetchAllPublishFlows,
  isFetching,
  sitesWithProgress,
}) => {
  const hasFetchedPublishFlows = useRef(false)

  useEffect(() => {
    if (!hasFetchedPublishFlows.current) {
      hasFetchedPublishFlows.current = true
      fetchAllPublishFlows()
    }
  }, [fetchAllPublishFlows])
  return (
    <AdminK8PrepareMultiSiteView
      isFetching={isFetching}
      sites={sitesWithProgress}
    />
  )
}

AdminK8PrepareMultiSiteViewContainer.propTypes = {
  fetchAllPublishFlows: PropTypes.func,
  isFetching: PropTypes.bool,
  sitesWithProgress: PropTypes.array,
}

const mapStateToProps = state => {
  const adminK8Sites = licenseSelectors.selectActiveAdminK8Sites(state)
  const publishFlows = ssapiSelectors.selectAllPublishFlows(state)
  const sitesWithProgress = addProgressToSites(adminK8Sites, publishFlows)
  const isFetching = state.licenseManger?.isFetchingUserSites || false
  return {
    sitesWithProgress,
    isFetching,
  }
}

const mapDispatchToProps = {
  fetchAllPublishFlows: ssapiOperations.fetchAllPublishFlows,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AdminK8PrepareMultiSiteViewContainer)
